import Image from 'next/image';
import { JSX } from 'react';

import { Button, Text } from '@videoblocks/design-system';

export interface CollectionViewItemProps {
    name: string;
    url: string;
    thumbnailUrl: string;
}

export const CollectionViewItem = ({ name, url, thumbnailUrl }: CollectionViewItemProps): JSX.Element => (
    <div
        data-testid={`collection-view-item-${name}`}
        className="w-full relative overflow-hidden h-[253px] text-center shrink-0 group rounded-lg"
    >
        <Image className="absolute object-cover" src={thumbnailUrl} alt={name} fill />
        <div className="absolute bg-black opacity-20 top-0 left-0 w-full h-full transition-opacity duration-300 group-hover:opacity-80 group-focus-within:opacity-80" />
        <div className="absolute w-full h-full top-0 left-0 p-1 flex flex-col justify-center items-center">
            <Text asChild fontSize="lg" className="text-white uppercase z-10">
                <h5 className="text-shadow-md">{name}</h5>
            </Text>
            {/* TODO: change to Next/Link when collection pages are in shell */}
            <Button
                variant="outlined-light"
                href={url}
                className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 group-focus-within:opacity-100 p-4"
            >
                View Collection
            </Button>
        </div>
    </div>
);
